export default {
  //constants.js --> offices
  offices: "Offices",
  liaison_office: "Liason Office",
  internship_office: "Internship Office",
  alumni_office: "Alumni Office",
  erasmus_office: "Erasmus Office",
  physical_education_office: "Physical Education Office",
  environmental_management_office: "Environmental Policy Office",
  //constants.js --> Student Teams
  student_clubs: "Student Clubs",
  uom_students_club: "UoM Students Club",
  erasmus_student_club: "Erasmus Student Club",
  cybersecurity_student_club: "Cybersecurity Club of University of Macedonia",
  open_source_club: "Open Source UoM",
  //constants.js --> Other Services
  ethics_research_committee: "Committee on Research Ethics and Integrity",
  student_advocate: "Student Advocate",
  gender_eq_committee: "Gender Equality Committee",
  student_consulting_support_center: "Student Consulting and Support Center",
  accessibility_unit: "UoM Accessibility Committee",
  theater_workshop: "",
  uni_publications: "University of Macedonia Publications",
};
